import {createActions} from 'reduxsauce';

export const {Types: ShopperTypes, Creators: ShopperActionCreators} = createActions({
    contactUsStart: null,
    shopperSendStart: ["body"],
    shopperSendSuccess: ['data'],
    shopperSendFailure: ['error'],
    resetShopperStatus: null,
});
